import { Component } from "react";
import { AlertTriangle } from "lucide-react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Nofina Movie error boundary:", error, info);
  }
  handleReset = () => {
    this.setState({ hasError: false });
    window.location.assign("/");
  };
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-nm-bg px-6">
          <div className="max-w-md text-center">
            <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-nm-surface2">
              <AlertTriangle className="h-7 w-7 text-nm-red" />
            </div>
            <h1 className="text-2xl font-bold text-nm-text">Terjadi kesalahan</h1>
            <p className="mt-2 text-nm-muted">
              Maaf, ada gangguan saat memuat halaman. Coba kembali ke beranda.
            </p>
            <button
              type="button"
              onClick={this.handleReset}
              className="mt-6 inline-flex h-11 items-center justify-center rounded-lg bg-nm-red px-6 font-semibold text-white transition-colors hover:bg-nm-red-hover"
            >
              Kembali ke Beranda
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
